<template>
  <div>
    <p class="profileBtn"><button @click="openDialog">Profile</button></p>
    <div v-if="dialog" class="modal">
      <div class="modal_wall" @click="closeDialog"></div>
      <div class="modal_body">
        <div class="modal_inner">
          <div class="modal_close"><span @click="closeDialog"><img src="/static/front/cross.png"></span></div>
          <div class="modal_content">
            <!--アーティスト詳細ここから-->
            <div class="artist-modal">
              <div class="artist-modal-inner">
                <div class="flexMobile-none mb-50">
                  <div>
                    <p class="modal-artistPhoto">
                      <img v-if="artistImg != null" :src="artistImg">
                      <img v-else src="/static/unknown.png">
                    </p>
                  </div>
                  <div class="mobile-center">
                    <!--<p class="subTitle">Composer / Pianist</p>-->
                    <p class="modalArtist-name">{{ artistName }}</p>
                    <p class="modalArtist-name-jp">{{ artistName_kana }}</p>
                    <p class="modalSns">
                      <a v-if="hp != null" v-bind:href="hp" target="_blank">
                        <img src="/static/front/hp.png">
                      </a>
                      <a v-if="facebook != null" v-bind:href="facebook" target="_blank">
                        <img class="pl-10" src="/static/front/face.png">
                      </a>
                      <a v-if="twitter != null" v-bind:href="twitter" target="_blank">
                        <img class="pl-10" src="/static/front/twitter.png">
                      </a>
                      <a v-if="blog != null" v-bind:href="blog" target="_blank">
                        <img class="pl-10" src="/static/front/blog.png">
                      </a>
                    </p>
                  </div>
                </div>
                <dl class="artist-dl">
                  <dt>Profile</dt>
                  <dd v-html="profile" style="white-space: pre-line;"></dd>
                </dl>
                <dl class="artist-dl">
                  <dt>Career</dt>
                  <dd v-html="career" style="white-space: pre-line;"><br>
                  </dd>
                </dl>
              </div>
            </div>
            <!--アーティスト詳細ここまで-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArtistProfile',
  data () {
    return {
      dialog: false
    }
  },
  props: ['artistImg', 'artistName', 'artistName_kana', 'profile', 'career', 'hp', 'facebook', 'twitter', 'blog'],
  methods: {
    openDialog: function () {
      this.dialog = true
    },
    closeDialog: function () {
      this.dialog = false
    }
  }
}
</script>

<style scoped>
@import "../assets/style/front.scss";
</style>



// WEBPACK FOOTER //
// src/components/ArtistProfile.vue